export enum OrganizationVersionEnum {
    Basic = 1,
    Advanced = 2,
}
